import type { TRouteHandle, TRouteHandleCrumb } from "@ch/helpers/utils/types";
import type { FC } from "react";
import { Link, type UIMatch, useMatches } from "react-router-dom";
import Icon from "../Icons/Icon";

interface BreadcrumbsProps {
  crumb?: TRouteHandleCrumb;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ crumb }) => {
  const matches = useMatches() as UIMatch<unknown, TRouteHandle>[];
  const routesCrumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map((match) => match.handle?.crumb?.(crumb));

  return (
    <div className="breadcrumbs text-sm capitalize">
      <ul>
        {routesCrumbs.map((routeCrumb, index) => (
          <li className="flex" key={`${index.toString()}${routeCrumb?.title}`}>
            {routeCrumb?.icon && (
              <span className="mr-2">
                <Icon name={routeCrumb.icon} size={16} />
              </span>
            )}
            {routeCrumb?.route ? (
              <Link to={routeCrumb.route}>{routeCrumb?.title}</Link>
            ) : routeCrumb?.onClick ? (
              <button
                className="btn btn-link"
                onClick={routeCrumb.onClick}
                type="button"
              >
                {routeCrumb?.title}
              </button>
            ) : (
              <span>{routeCrumb?.title}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
